module.exports = __webpack_public_path__ + "static/GorditaLight-Italic-03d9b3eabdc67b9c13212a4c0eb6464d.otf";